/* eslint-disable react/require-default-props */
import React, { FunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import { CustomerType } from '../../../resources/base/models/enums';
import { assertDefined } from '../../../services/common/miscUtils';
import { customerSelectors } from '../../../services/redux/features/customer.slice';
import { quoteSelectors } from '../../../services/redux/features/quote.slice';
import { BusinessProspectForm } from './BusinessProspectForm';
import { CoCustomerProspectForm } from './CoCustomerProspectForm';
import { PrivateProspectForm } from './PrivateProspectForm';

interface Props {
  isCoCustomer?: boolean;
}

export const ProspectPageForm: FunctionComponent<Props> = ({ isCoCustomer }) => {
  const quoteId = assertDefined(useSelector(quoteSelectors.selectQuoteId));
  const milesCustomerIdFromQuote = useSelector(quoteSelectors.selectMilesCustomerIdFromQuote);
  const quoteCustomerType = useSelector(quoteSelectors.selectCustomerTypeFromQuote);
  const customerType = useSelector(customerSelectors.selectCustomerType);
  const customerId = useSelector(customerSelectors.selectCustomerId);
  const isQuoteEditable = useSelector(quoteSelectors.selectIsQuoteEditable);
  const milesCustomerIdCoCustomer = useSelector(customerSelectors.selectCoCustomerId);

  const customerTypeChanged = quoteCustomerType !== customerType;

  // eslint-disable-next-line no-nested-ternary
  const milesCustomerId = isQuoteEditable
    ? customerTypeChanged
      ? ''
      : milesCustomerIdFromQuote || customerId
    : milesCustomerIdFromQuote;

  if (isCoCustomer) {
    return <CoCustomerProspectForm initialMilesCustomerId={milesCustomerIdCoCustomer} quoteId={quoteId} />;
  }
  if (customerType === CustomerType.INDIVIDUAL) {
    return <PrivateProspectForm initialMilesCustomerId={milesCustomerId} quoteId={quoteId} />;
  }
  return <BusinessProspectForm initialMilesCustomerId={milesCustomerId} quoteId={quoteId} />;
};
